// @flow

import type {
  EventSourceMap,
  EasyAction,
  BasicProps,
  EasyCompMap,
  PropsSchema
} from '../../type'

import * as React from 'react'
import { customRender } from '../EasyCompComponent'
import computeData from '../hoc/computeData'
import { getPageInfo } from '../../pageInfo'

type Props = BasicProps & {
  url: string,
  method: string,
  showLoading: boolean,
  events: EventSourceMap,
  reqParam?: any,
  client?: string,
  needToSave: boolean,
  namespace: ?string,
  children?: Array<EasyCompMap>,
  formValues: { [string]: any },
  customProps?: any,
  propsName?: string,
  isFlatList?: boolean,
  onlyChangeItems: ?boolean
};

type State = {
  items: Array<*>
};

@computeData({ includeData: true, annotation: '//接收字段items' })
export default class Iterator extends React.Component<Props, State> {
  static defaultProps = {
    isShow: true,
    needToSave: false
  };

  fromProps = true;

  componentDidMount () {
    this.setItemsFromProps(this.props)
  }

  shouldComponentUpdate (nextProps: Props, nextState: State) {
    if (nextProps.jsEnv !== this.props.jsEnv) {
      this.setItemsFromProps(nextProps)
    }
    const { onlyChangeItems } = nextProps
    return onlyChangeItems ? this.state.items !== nextState.items : true
  }

  setItemsFromProps (props: Props) {
    if (this.fromProps) {
      this.setState({
        items: props.jsEnv.runCode('items') || []
      })
    }
  }

  static schema: PropsSchema = [
    {
      key: 'propsName',
      type: 'text',
      title: '属性名称'
    },
    {
      type: 'boolean',
      title: '使用flatList',
      key: 'isFlatList',
      defaultValue: true,
      visible: () => getPageInfo().platform === 'app'
    },
    {
      type: 'boolean',
      title: '只在items变时渲染',
      key: 'onlyChangeItems'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '向前追加',
      name: 'appendFront'
    },
    {
      title: '向后追加',
      name: 'appendEnd'
    },
    {
      title: '删除',
      name: 'removeItem',
      dataSchema: [
        {
          key: 'index',
          title: '索引',
          required: true
        }
      ]
    }
  ];

  state = { items: [] };

  actionRemoveItem = ({ index }: { index: string }, dynamicData: any) => {
    let items = [...this.state.items]
    const { jsEnv } = this.props
    const indexNum = jsEnv.getStringWithAdditionCtx(index, dynamicData) // : undefined
    if (indexNum) {
      items.splice(parseInt(indexNum, 10), 1)
      this.setState({
        items
      })
    }
  };

  actionAppendFront = (data: void, items: any) => {
    this.fromProps = false
    if (!(items instanceof Array)) {
      items = [items]
    }
    let { items: preItems } = this.state
    this.setState({
      items: [...items, ...preItems]
    })
  };

  actionAppendEnd = (data: void, items: any) => {
    this.fromProps = false
    if (!(items instanceof Array)) {
      items = [items]
    }
    let { items: preItems } = this.state
    this.setState({
      items: [...preItems, ...items]
    })
  };

  renderChild = (
    items: Array<*>,
    parentCustProps: any,
    $propsNames: Array<string>
  ) => {
    const { propsName, children, customProps = {} } = this.props
    return items.map((item, i: number) => {
      if (!(item instanceof Object)) {
        item = { value: item }
      }
      const iteratorIndex = [...(customProps.$indexes || []), i]
      if (!$propsNames.includes('$indexes')) {
        $propsNames.push('$indexes')
      }
      let nextCustomProps = {
        ...parentCustProps,
        $propsNames,
        $index: i,
        $last: i === items.length - 1,
        ...item,
        $indexes: iteratorIndex
      }
      if (propsName) {
        nextCustomProps[propsName] = {
          ...item,
          $index: i
        }
      }
      return customRender(
        children,
        {
          customProps: nextCustomProps
        },
        iteratorIndex
      )
    })
  };

  render () {
    const { visible, customProps = {}, propsName, isFlatList } = this.props
    if (!visible) {
      return null
    }
    const { children } = this.props
    let { items } = this.state
    if (!items || items.length === 0 || !children) {
      return null
    }
    if (!Array.isArray(items)) {
      return null
    }
    let { $propsNames = [] } = customProps
    let parentCustProps = {}

    $propsNames.forEach(key => {
      parentCustProps[key] = customProps[key]
    })
    if (propsName) {
      $propsNames = $propsNames.concat([propsName, '$index'])
    }
    if (isFlatList && getPageInfo().platform === 'app') {
      return <div>{this.renderChild(items, parentCustProps, $propsNames)}</div>
    }
    return this.renderChild(items, parentCustProps, $propsNames)
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/Iterator.js